module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays.56b46bd1.webp";